import React from "react";
import { LiveKitPlayer } from "./components/player";
import { LiveKitProvider } from "./context";

export type LiveKitCam2CamProps = {
  memberName: string;
  userName: string;
  userId: string;
  room: string;
  onSuccess: () => void;
  onFail: (error: any) => void;
  onDisconnect: () => void;
};

export const LiveKitCam2Cam: React.FC<LiveKitCam2CamProps> = ({
  memberName,
  userName,
  userId,
  room,
  onSuccess,
  onFail,
  onDisconnect,
}) => {
  return (
    <LiveKitProvider userName={userName} userId={userId} room={room}>
      <LiveKitPlayer
        memberName={memberName}
        onSuccess={onSuccess}
        onFail={onFail}
        onDisconnect={onDisconnect}
      />
    </LiveKitProvider>
  );
};
